import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

export const LandingView = (props) => {
  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Switch>
        <Route
          path={`/app/home`}
          component={lazy(() => import(`./DetailPage`))}
        />
        <Route
          path={`/app/webform`}
          component={lazy(() => import(`./WebFormView`))}
        />

        <Route
          path={`/app/tracking/:track_id`}
          component={lazy(() => import(`./WhistleblowingProgress`))}
        />

        <Route
          path={`/app/tracking`}
          component={lazy(() => import(`./WhistleblowingProgress`))}
        />
        
        <Route
          path={`/app/detail_pdf`}
          component={lazy(() => import(`./DetailPdfPage`))}
        />

        <Route
          path={`/app/qr_check/:id`}
          component={lazy(() => import(`./QRScanResultPage`))}
        />

        {/* <Route path={`${AUTH_PREFIX_PATH}/login-1`} component={lazy(() => import(`./authentication/login-1`))} />
        <Route path={`${AUTH_PREFIX_PATH}/login-2`} component={lazy(() => import(`./authentication/login-2`))} />
        <Route path={`${AUTH_PREFIX_PATH}/register-1`} component={lazy(() => import(`./authentication/register-1`))} />
        <Route path={`${AUTH_PREFIX_PATH}/register-2`} component={lazy(() => import(`./authentication/register-2`))} />
        <Route path={`${AUTH_PREFIX_PATH}/forgot-password`} component={lazy(() => import(`./authentication/forgot-password`))} />
        <Route path={`${AUTH_PREFIX_PATH}/error-1`} component={lazy(() => import(`./errors/error-page-1`))} />
        <Route path={`${AUTH_PREFIX_PATH}/error-2`} component={lazy(() => import(`./errors/error-page-2`))} /> */}
        <Redirect from={`/`} to={`/app/home`} />
      </Switch>
    </Suspense>
  );
};

export default LandingView;
